import { CrmProvider } from "@/pages/Private/redux/crm/crm.schema";

import { useProviderConnectionStatus } from "./useProviderConnectionStatus";

/**
 * Returns the CRM providers the company has actually connected (OAuth or API key).
 * Used to render "Add to CRM" menus with only the activated providers — a CRM that
 * isn't connected can't receive prospects, so it should not be offered.
 */
export const useConnectedCrmProviders = (): CrmProvider[] => {
	const isHubspotConnected = useProviderConnectionStatus("hubspot");
	const isZohoConnected = useProviderConnectionStatus("zoho");
	const isPipedriveConnected = useProviderConnectionStatus("pipedrive");
	const isDynamicsConnected = useProviderConnectionStatus("msdynamics");
	const isSalesforceConnected = useProviderConnectionStatus("salesforce");

	return [
		isHubspotConnected && CrmProvider.HUBSPOT,
		isZohoConnected && CrmProvider.ZOHO,
		isPipedriveConnected && CrmProvider.PIPEDRIVE,
		isDynamicsConnected && CrmProvider.MSDYNAMICS,
		isSalesforceConnected && CrmProvider.SALESFORCE,
	].filter((provider): provider is CrmProvider => Boolean(provider));
};
